/* Sunset Performance — in-house YMM Garage (vanilla, no deps).
 * Year -> Make -> Model -> Submodel cascade with NO dead ends, driven by
 * assets/fitment_cascade.json. Persists the chosen vehicle in localStorage and
 * navigates to a fit_make_/fit_model_ tag-filtered collection on "Find Parts".
 * The fit_* tags are written to products by agent_bridge.sunset_ymm_tags.
 */
(function () {
  "use strict";
  var STORE_KEY = "sunset_vehicle_v2"; // Phase 0: bump ignores stale saves that deep-linked to old-scheme URLs
  var DATA = null;

  function slug(s) {
    return (s || "").toString().trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
  }
  function opt(value, label) {
    var o = document.createElement("option");
    o.value = value; o.textContent = label == null ? value : label;
    return o;
  }
  function reset(sel, placeholder) {
    sel.innerHTML = "";
    sel.appendChild(opt("", placeholder));
    sel.disabled = true;
  }

  function init(section) {
    var url = section.getAttribute("data-cascade-url");
    var target = section.getAttribute("data-target-collection") || "all";
    var ySel = section.querySelector('[data-ymm="year"]');
    var mkSel = section.querySelector('[data-ymm="make"]');
    var mdSel = section.querySelector('[data-ymm="model"]');
    var subSel = section.querySelector('[data-ymm="submodel"]');
    var go = section.querySelector("[data-ymm-go]");
    var form = section.querySelector("[data-ymm-form]");
    var chip = section.querySelector("[data-ymm-chip]");
    var chipLabel = section.querySelector("[data-ymm-chip-label]");
    var clearBtn = section.querySelector("[data-ymm-clear]");
    var bar = section.querySelector("[data-ymm-bar]");
    var barLink = section.querySelector("[data-ymm-bar-link]");
    var barLabel = section.querySelector("[data-ymm-bar-label]");
    var barChange = section.querySelector("[data-ymm-bar-change]");
    var barClear = section.querySelector("[data-ymm-bar-clear]");

    // Build the fit-tag for a vehicle (same rule used on submit).
    function fitTag(v) {
      return v.model
        ? "fit_model_" + slug(v.make) + "-" + slug(v.model)
        : "fit_make_" + slug(v.make);
    }
    // Build the destination collection URL. Honors the current collection context
    // when present (so the saved bar deep-links within the browsed category),
    // else falls back to the section's default target collection.
    function fitUrl(v) {
      var handle = target;
      var m = window.location.pathname.match(/^\/collections\/([^\/]+)/);
      if (m && m[1] && m[1] !== "all") handle = decodeURIComponent(m[1]);
      return "/collections/" + encodeURIComponent(handle) + "/" + encodeURIComponent(fitTag(v));
    }
    // Phase 0: pick the navigation destination. A model-level pick uses the live
    // fit_model_ collection. A make-ONLY pick (no model) goes to keyword search
    // instead of a whole-make collection, which surfaced parts for the entire make
    // regardless of the shopper's actual model.
    function destination(v) {
      if (v.model) return fitUrl(v);
      return "/search?q=" + encodeURIComponent([v.year, v.make].filter(Boolean).join(" "));
    }
    function vehicleLabel(v) {
      return [v.year, v.make, v.model, (v.submodel && v.submodel !== "(all)") ? v.submodel : ""]
        .filter(Boolean).join(" ");
    }

    function years() {
      return Object.keys(DATA.makes_by_year).map(Number).sort(function (a, b) { return b - a; });
    }
    function makesForYear(y) {
      return (DATA.makes_by_year[String(y)] || []).slice().sort();
    }
    function modelsFor(y, mk) {
      var tree = DATA.tree[mk] || {};
      return Object.keys(tree).filter(function (md) {
        return Object.keys(tree[md]).some(function (sub) { return tree[md][sub].indexOf(y) !== -1; });
      }).sort();
    }
    function submodelsFor(y, mk, md) {
      var node = (DATA.tree[mk] || {})[md] || {};
      return Object.keys(node).filter(function (sub) { return node[sub].indexOf(y) !== -1; }).sort();
    }

    function refreshGo() {
      go.disabled = !(ySel.value && mkSel.value); // year+make minimum; model/submodel narrow further
    }

    function fillYears() {
      reset(ySel, "Year"); ySel.disabled = false;
      years().forEach(function (y) { ySel.appendChild(opt(String(y))); });
    }
    function onYear() {
      reset(mkSel, "Make"); reset(mdSel, "Model"); reset(subSel, "Submodel");
      if (ySel.value) {
        mkSel.disabled = false;
        makesForYear(Number(ySel.value)).forEach(function (mk) { mkSel.appendChild(opt(mk)); });
      }
      refreshGo();
    }
    function onMake() {
      reset(mdSel, "Model"); reset(subSel, "Submodel");
      if (ySel.value && mkSel.value) {
        mdSel.disabled = false;
        modelsFor(Number(ySel.value), mkSel.value).forEach(function (md) { mdSel.appendChild(opt(md)); });
      }
      refreshGo();
    }
    function onModel() {
      reset(subSel, "Submodel");
      if (ySel.value && mkSel.value && mdSel.value) {
        var subs = submodelsFor(Number(ySel.value), mkSel.value, mdSel.value);
        if (subs.length && !(subs.length === 1 && subs[0] === "(all)")) {
          subSel.disabled = false;
          subs.forEach(function (s) { subSel.appendChild(opt(s, s === "(all)" ? "All submodels" : s)); });
        }
      }
      refreshGo();
    }

    function saveVehicle() {
      var v = { year: ySel.value, make: mkSel.value, model: mdSel.value, submodel: subSel.value, schema: 2 };
      // Phase 0: persist ONLY the vehicle, never a resolved tag/URL. The destination
      // is always recomputed through destination() at click time, so a future tag-scheme
      // change can't leave a stale deep-link behind.
      try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {}
      renderChip(v); renderBar(v);
    }
    function renderChip(v) {
      if (!v || !v.year || !v.make) { chip.hidden = true; return; }
      chipLabel.textContent = vehicleLabel(v);
      chip.hidden = false;
    }
    function renderBar(v) {
      if (!bar) return;
      if (!v || !v.year || !v.make) { bar.hidden = true; return; }
      barLabel.textContent = vehicleLabel(v);
      // Phase 0: always recompute the destination (honors current collection context
      // and the make-only search fallback); never trust a stored URL.
      barLink.setAttribute("href", destination(v));
      bar.hidden = false;
    }
    function hideBars() {
      chip.hidden = true;
      if (bar) bar.hidden = true;
    }
    function restore() {
      var raw; try { raw = localStorage.getItem(STORE_KEY); } catch (e) { raw = null; }
      if (!raw) return;
      var v; try { v = JSON.parse(raw); } catch (e) { return; }
      if (!v || !v.year || !v.make) return;
      // replay the cascade so dropdowns reflect the saved vehicle
      ySel.value = String(v.year); onYear();
      if ([].slice.call(mkSel.options).some(function (o) { return o.value === v.make; })) {
        mkSel.value = v.make; onMake();
        if (v.model && [].slice.call(mdSel.options).some(function (o) { return o.value === v.model; })) {
          mdSel.value = v.model; onModel();
          if (v.submodel) { subSel.value = v.submodel; }
        }
      }
      refreshGo(); renderChip(v); renderBar(v);
    }

    function clearVehicle() {
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      fillYears(); reset(mkSel, "Make"); reset(mdSel, "Model"); reset(subSel, "Submodel");
      refreshGo(); hideBars();
    }
    function focusGarage() {
      // Reopen/repopulate the garage: scroll the (already pre-filled) form into
      // view and focus the first empty cascade step.
      form.scrollIntoView({ behavior: "smooth", block: "center" });
      var firstOpen = [ySel, mkSel, mdSel, subSel].filter(function (s) { return !s.disabled; });
      var pick = firstOpen.length ? firstOpen[0] : ySel;
      try { pick.focus(); } catch (e) {}
    }

    ySel.addEventListener("change", onYear);
    mkSel.addEventListener("change", onMake);
    mdSel.addEventListener("change", onModel);
    subSel.addEventListener("change", refreshGo);
    clearBtn.addEventListener("click", clearVehicle);
    if (barClear) barClear.addEventListener("click", clearVehicle);
    if (barChange) barChange.addEventListener("click", function (e) { e.preventDefault(); focusGarage(); });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!ySel.value || !mkSel.value) return;
      saveVehicle(); // persists vehicle + fit tag/url
      // This store filters via the URL PATH /collections/<handle>/<tag>, matching the
      // LITERAL tag (underscores preserved) — confirmed live: /collections/all/fit_model_ford-f-150
      // filters correctly. (NOT the ?filter.p.tag= facet param, which is dead on this store.)
      // fitUrl() honors the current collection context (e.g. /collections/coilovers-springs)
      // so the shopper gets "<category> for <their car>"; off-collection falls back to "all".
      window.location.href = destination({ year: ySel.value, make: mkSel.value, model: mdSel.value });
    });

    // Render the persistent bar IMMEDIATELY from localStorage — it does not depend on
    // the cascade JSON, so the "Shopping for" bar shows on every page even before (or if)
    // the fitment data finishes loading.
    (function showSavedBarEarly() {
      var raw; try { raw = localStorage.getItem(STORE_KEY); } catch (e) { raw = null; }
      if (!raw) return;
      var v; try { v = JSON.parse(raw); } catch (e) { return; }
      if (v && v.year && v.make) renderBar(v);
    })();

    // Performance: defer the ~63KB fitment_cascade.json fetch so it stops competing
    // with the LCP hero image on a cold mobile load. The persistent "Shopping for"
    // bar already rendered above from localStorage and does NOT need this data.
    // The cascade loads lazily on first interaction with the garage (focus/pointer/
    // touch), with an idle-time fallback so the dropdowns still populate for a user
    // who just sits there. loadCascade() is idempotent.
    var cascadeStarted = false;
    function loadCascade() {
      if (cascadeStarted) return;
      cascadeStarted = true;
      removeLazyTriggers();
      fetch(url).then(function (r) { return r.json(); }).then(function (json) {
        DATA = json;
        fillYears();
        restore();
      }).catch(function (err) {
        cascadeStarted = false; // allow a retry on next interaction
        var note = section.querySelector("[data-ymm-note]");
        if (note) note.textContent = "Vehicle lookup is loading… (" + err + ")";
      });
    }

    var LAZY_EVENTS = ["focusin", "pointerdown", "touchstart", "mouseover"];
    function onLazyTrigger() { loadCascade(); }
    function removeLazyTriggers() {
      LAZY_EVENTS.forEach(function (ev) {
        section.removeEventListener(ev, onLazyTrigger, true);
      });
    }
    LAZY_EVENTS.forEach(function (ev) {
      section.addEventListener(ev, onLazyTrigger, { capture: true, passive: true });
    });

    // Idle fallback: if the visitor never touches the garage, load the cascade once
    // the main thread is idle (or after a short delay) so the dropdowns are ready
    // and a saved vehicle can be replayed — well after the LCP window has closed.
    if ("requestIdleCallback" in window) {
      requestIdleCallback(function () { loadCascade(); }, { timeout: 6000 });
    } else {
      setTimeout(loadCascade, 4000);
    }
  }

  function boot() {
    document.querySelectorAll("[data-ymm-section]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  /* ------------------------------------------------------------------ *
   * Search <-> Garage bridge (Phase-0 interim).
   * Scopes the keyword search to the shopper's vehicle via Shopify's
   * filter.p.tag, using the fit_model_ tags already on products — so
   * "coilovers" narrows from ~1000 to the ~37 that actually fit.
   * Two sources, typed query wins over the garaged vehicle:
   *   (1) a vehicle name typed in the query (e.g. "gt86 coilovers")
   *   (2) the vehicle saved in the garage
   * Only the result set narrows; the facet UI stays hidden (show_filter=false),
   * so the search page looks unchanged. Uses the SAME slug() + STORE_KEY as the
   * garage. This is interim: it inherits the current tags' limits (GT86/GR86
   * still share, universals can slip in) until the full rebuild.
   * ------------------------------------------------------------------ */
  // Common performance-vehicle names -> a fit_model_ tag VERIFIED to exist live.
  // (STI has no own tag -> WRX, its platform. Extend as the rebuild lands.)
  var VEH_ALIAS = {
    "gt86": "toyota-86", "gt-86": "toyota-86", "86": "toyota-86",
    "gr86": "toyota-gr86", "gr-86": "toyota-gr86",
    "frs": "scion-fr-s", "fr-s": "scion-fr-s",
    "brz": "subaru-brz",
    "wrx": "subaru-wrx", "sti": "subaru-wrx",
    "supra": "toyota-supra",
    "350z": "nissan-350z", "370z": "nissan-370z",
    "gtr": "nissan-gt-r", "gt-r": "nissan-gt-r", "r35": "nissan-gt-r",
    "civic": "honda-civic", "s2000": "honda-s2000", "s2k": "honda-s2000",
    "mustang": "ford-mustang",
    "camaro": "chevrolet-camaro",
    "corvette": "chevrolet-corvette", "vette": "chevrolet-corvette",
    "miata": "mazda-mx-5-miata", "mx5": "mazda-mx-5-miata", "mx-5": "mazda-mx-5-miata",
    "golf-r": "volkswagen-golf-r", "golfr": "volkswagen-golf-r"
  };
  function savedFitTag() {
    var raw; try { raw = localStorage.getItem(STORE_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var v; try { v = JSON.parse(raw); } catch (e) { return null; }
    if (!v || !v.make || !v.model) return null; // need a model for a fit_model_ tag
    return "fit_model_" + slug(v.make) + "-" + slug(v.model);
  }
  function typedScope(q) {
    if (!q) return null;
    var norm = " " + q.toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim() + " ";
    var keys = Object.keys(VEH_ALIAS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var phrase = " " + keys[i] + " ";
      if (norm.indexOf(phrase) !== -1) {
        var rest = norm.split(phrase).join(" ").replace(/\s+/g, " ").trim();
        return { tag: "fit_model_" + VEH_ALIAS[keys[i]], rest: rest };
      }
    }
    return null;
  }
  // Delegated + capture so it runs before the theme's own submit handler; the form
  // then submits natively (GET) with our hidden filter input included.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;
    var isSearch = (form.getAttribute("action") || "").toLowerCase().indexOf("/search") !== -1;
    // The facet sidebar form on the search-results page: re-assert the saved vehicle
    // so clicking a category/brand/price filter never drops the shopper's car.
    var isFacet = form.id === "CollectionFiltersForm" && location.pathname.toLowerCase().indexOf("/search") !== -1;
    if (!isSearch && !isFacet) return;
    var tag = null;
    if (isSearch) {
      var qi = form.querySelector('input[name="q"]');
      if (!qi) return;
      var typed = typedScope(qi.value);
      if (typed) {
        if (typed.rest) qi.value = typed.rest; // drop the vehicle word so the filter can narrow
        tag = typed.tag;
      } else {
        tag = savedFitTag();
      }
    } else {
      tag = savedFitTag(); // facet form: keep the vehicle scope
    }
    if (!tag) return;
    var inp = form.querySelector('input[name="filter.p.tag"]');
    if (!inp) {
      inp = document.createElement("input");
      inp.type = "hidden"; inp.name = "filter.p.tag";
      form.appendChild(inp);
    }
    inp.value = tag;
  }, true);

  /* On the results page, show a "Fits <Vehicle>" chip so a scoped search never
   * reads as if it dropped the car (e.g. heading "124 results for 'brakes'").
   * Prefers the garaged vehicle's full label (with year) when it matches the
   * applied tag; else derives a name from the tag itself. NOTE: the underlying
   * tag is model-level only, so results are NOT year-filtered yet — that lands
   * with the rebuild. The chip intentionally says "(all years)" to stay honest. */
  function tagToName(tag) {
    var body = tag.replace(/^fit_model_/, "").replace(/^fit_make_/, "");
    return body.split("-").map(function (w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).join(" ");
  }
  (function showScopeChip() {
    if (location.pathname.indexOf("/search") === -1) return;
    var params = new URLSearchParams(location.search);
    var tag = params.get("filter.p.tag");
    if (!tag || tag.indexOf("fit_") !== 0) return;
    var name = null, exactYears = false;
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (raw) {
        var v = JSON.parse(raw);
        if (v && v.make && v.model &&
            ("fit_model_" + slug(v.make) + "-" + slug(v.model)) === tag) {
          name = [v.make, v.model].join(" "); // model-level tag: no year filtering yet
        }
      }
    } catch (e) {}
    if (!name) name = tagToName(tag);
    function inject() {
      var h = document.querySelector(".m-page-header__title");
      if (!h || document.querySelector("[data-ymm-scope-chip]")) return;
      var chip = document.createElement("div");
      chip.setAttribute("data-ymm-scope-chip", "");
      chip.style.cssText = "display:inline-flex;align-items:center;gap:.4em;margin:.5em auto 0;" +
        "padding:.35em .8em;border-radius:999px;background:rgba(0,0,0,.06);" +
        "font-size:.85em;font-weight:600;line-height:1.2;";
      chip.innerHTML = '<span aria-hidden="true">🔧</span><span>Fits ' +
        name.replace(/</g, "&lt;") + ' <span style="font-weight:400;opacity:.7">(all years)</span></span>';
      h.parentNode.insertBefore(chip, h.nextSibling);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", inject);
    else inject();
  })();
})();
